module.exports = __webpack_public_path__ + "static/media/MannaProviderLogo.24bd4a2d.png";